import './Home.css'
import React, { useContext, useState } from 'react'
import Add from '../image/add_user.png'
import Messages from './Messages'
import Input from './Input'
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  arrayUnion,
} from 'firebase/firestore'
import { db } from '../../config'
import { ChatContext } from '../../context/ChatContext'

const Chat = () => {
  const [user, setUser] = useState(null)
  const { data } = useContext(ChatContext)

  const handleAdd = async () => {
    var inputMail = prompt('Please enter the email: ')
    if (inputMail != null) {
      const q = query(collection(db, 'user'), where('email', '==', inputMail))

      try {
        const querySnapshot = await getDocs(q)
        querySnapshot.forEach((doc) => {
          setUser(doc.data())
        })

        await updateDoc(doc(db, 'groups', data.groupId), {
          member: arrayUnion(user.uid),
        })

        await updateDoc(doc(db, 'usergroups', user.uid), {
          [data.groupId + '.groupInfo']: {
            groupName: data.groupName,
          },
        })
      } catch (err) {
        console.log(err.message)
        alert(err.code)
      }
    }
  }

  return (
    <div className="chat">
      <div className="chatInfo">
        <span className="curChat">{data.groupName}</span>
        <div className="addMember" onClick={handleAdd}>
          <img src={Add} alt="" className="addUser" />
        </div>
      </div>
      <Messages />
      <Input />
    </div>
  )
}

export default Chat
